<template>
<div  :class="$style['order-patient-message']">
    <pt-sub-title title="受检人信息"></pt-sub-title>
    <table :class="$style['order-patient-message-table']">
        <pt-message-table-item label="受检人姓名">
            {{patient.name}}
        </pt-message-table-item>
        <pt-message-table-item label="性别">
            {{patient.sex}}
        </pt-message-table-item>
        <pt-message-table-item label="出生日期">
            {{patient.birth_day}}
        </pt-message-table-item>
        <pt-message-table-item label="证件类型">
            {{patient.idCardType}}
        </pt-message-table-item>
        <pt-message-table-item label="证件号码">
            {{patient.identityCard}}
        </pt-message-table-item>
        <pt-message-table-item label="婚姻状况">
            {{patient.marry}}
        </pt-message-table-item>
        <pt-message-table-item label="联系方式">
            {{patient.mobile}}
        </pt-message-table-item>
    </table>
</div>
</template>
<script>
export default {
  props: {
    patient: {
      type: Object,
      default: function () {
        return {}
      }
    },
    tdMaxWidth: {
      type: [Number, String],
      default: 0
    }
  }
}
</script>
<style module lang="less">
.order-patient-message{

}
.order-patient-message-table{
    padding: 20px;
}
</style>
